import React from 'react';
import {
  Cushion,
  FlexContainer,
  Grid,
  MaxWidth,
  ShimmerIcon,
  Space,
  ShimmerTypography,
  ShimmerAvatar,
  Shimmer,
} from '@pitchero/react-ui';

const TrainingSessionLoadingState = () => (
  <Cushion all="medium" responsive={[{ maxWidth: 'tab', props: { horizontal: 'small' } }]}>
    <MaxWidth component="div" maxWidth={1366} center>
      <Grid preset="training">
        <Cushion all="large" style={{ gridArea: 'overview' }} component="div">
          <Space bottom="small">
            <FlexContainer justifyContent="space-between">
              <ShimmerTypography preset="tab--active" width="60%" />
              <ShimmerIcon size={32} />
            </FlexContainer>
          </Space>
          <FlexContainer justifyContent="space-between">
            <ShimmerTypography preset="tag--large" width="30%" />
            <ShimmerTypography preset="tag--large" width="20%" />
          </FlexContainer>
        </Cushion>
        <Cushion horizontal="small" style={{ gridArea: 'availability' }} component="div">
          <FlexContainer flexDirection="row" justifyContent="space-between" alignItems="center">
            <ShimmerAvatar size={40} />
            <ShimmerTypography preset="body--large" width="50%" />
            <Shimmer preset="title" height={28} width={52} radius={14} />
          </FlexContainer>
        </Cushion>
        <Cushion all="large" style={{ gridArea: 'details' }} component="div">
          <Space bottom="large">
            <ShimmerTypography preset="tab--active" width="60%" />
            <ShimmerTypography preset="body--large" width="30%" />
            <ShimmerTypography preset="body--large" width="30%" />
            <ShimmerTypography preset="body--large" width="30%" />
          </Space>
          <ShimmerTypography preset="tab--active" width="60%" />
          <ShimmerTypography preset="body--large" width="100%" />
          <ShimmerTypography preset="body--large" width="100%" />
          <ShimmerTypography preset="body--large" width="30%" />
        </Cushion>
        <Cushion all="large" style={{ gridArea: 'attendees' }} component="div">
          <Space bottom="large">
            <ShimmerTypography preset="tab--active" width="60%" />
            <ShimmerTypography preset="body--large" width="20%" />
            <ShimmerTypography preset="body--large" width="20%" />
          </Space>
          <Space bottom="large">
            <ShimmerTypography preset="tab--active" width="60%" />
            <Space vertical="small">
              <ShimmerAvatar size={48} />
            </Space>
            <ShimmerTypography preset="description" width="20%" />
          </Space>
        </Cushion>
      </Grid>
    </MaxWidth>
  </Cushion>
);

export default TrainingSessionLoadingState;
